import styled from 'styled-components'
import { NEUTRAL_100 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Overlay = (styled.div<{ $isOpen: boolean, $overlayOpacity?: number }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, ${props => props.$overlayOpacity || 0.5});
    display: ${props => props.$isOpen ? 'block' : 'none'};
    z-index: 1000;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Container = (styled.div<{ $isOpen: boolean, $height: string }>`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${props => props.$height};
    background-color: white;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    transform: translateY(${props => props.$isOpen ? '0' : '100%'});
    transition: transform 0.3s ease-out;
    display: flex;
    flex-direction: column;
    z-index: 1001;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Header = (styled.div`
    padding: 16px;
    border-bottom: 1px solid ${NEUTRAL_100};
    font-family: ${INTER.semiBold};
    display: flex;
    justify-content: space-between;
    align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Content = (styled.div`
    padding: 16px 12px;
    overflow-y: auto;
    flex: 1;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Footer = (styled.div`
    padding: 16px;
    border-top: 1px solid ${NEUTRAL_100};
    display: flex;
    justify-content: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
